export default __webpack_public_path__ + "static/media/high-risk.5946be41.svg";